export default class {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
        }
    }
    // fetch(options){
    //     let params = []
    //     let organizationID = options.organizationID
    //     delete options.organizationID

    //     for(let [key, value] of Object.entries(options)){
    //         params.push(`${key}=${value}`)
    //     }

    //     return this.client.get(`/visits?${params.join('&')}`)
    // }
    // mark ***
    create(options){
        return this.client.post(`/visits`,options)
    }
}


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/visits.js